import { render, staticRenderFns } from "./OutboundType.vue?vue&type=template&id=5a665164&scoped=true"
import script from "./OutboundType.vue?vue&type=script&lang=js"
export * from "./OutboundType.vue?vue&type=script&lang=js"
import style0 from "./OutboundType.vue?vue&type=style&index=0&id=5a665164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a665164",
  null
  
)

export default component.exports